import { fetchJson } from "@/helpers/fetch";
import { RechargeAddress } from "../portal";

export const RECHARGE_BASE_URL = "/tools/recurring/portal/";

type RechargeChargeResponse = {
  id: number;
  scheduled_at: string;
};
export interface ModifiedCharge {
  id: number;
  scheduleAt: Date;
}

export const fetchUpcomingCharge = async (
  rechargeAddressId: number,
  customerHash: string,
  customerToken: string
): Promise<ModifiedCharge | null> => {
  const schema = `{ "charges": { "address_id": ${rechargeAddressId}, "status": "QUEUED" } }`;
  const url = `${RECHARGE_BASE_URL}${customerHash}/request_objects?token=${customerToken}&schema=${schema}`;

  try {
    const response: { charges: RechargeChargeResponse[] } = await fetchJson(
      url
    );

    if (response.charges && response.charges.length > 0) {
      return findUpcomingCharge(response.charges);
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch charges:", error);
    return null;
  }
};

export const fetchRechargeAddresses = async (
  customerHash: string,
  customerToken: string
) => {
  const schema = '{ "addresses": {} }';
  const url = `${RECHARGE_BASE_URL}${customerHash}/request_objects?token=${customerToken}&schema=${schema}`;

  try {
    const response: { addresses: RechargeAddress[] } = await fetchJson(url);

    if (response.addresses && response.addresses.length > 0) {
      return response.addresses;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch charges:", error);
    return null;
  }
};

function findUpcomingCharge(
  chargeArray: RechargeChargeResponse[]
): ModifiedCharge | null {
  if (chargeArray.length === 0) {
    return null;
  }

  // Find the charge with the nearest future date
  const nearestCharge = chargeArray.reduce((nearestCharge, currentCharge) => {
    return new Date(currentCharge.scheduled_at) <
      new Date(nearestCharge.scheduled_at)
      ? currentCharge
      : nearestCharge;
  });

  // Convert the scheduled_at property to a Date object
  return {
    id: nearestCharge.id,
    scheduleAt: new Date(nearestCharge.scheduled_at),
  };
}
